import React, { useState } from 'react';
import { Container, Button, Card, Form } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { Btn, H5 } from '../../../../AbstractElements';
import { Input, ModalBody, ModalHeader, ModalFooter, Modal } from 'reactstrap';
import CloseModal from '../../../../Constant/CloseModal';

const AddNotes = () => {
  const [notes, setNotes] = useState([]);

  const addNote = () => {
    const now = new Date().toLocaleDateString(); // Get current date
    setNotes([
      ...notes,
      { id: Date.now(), date: now, title: '', content: '', name: '' }
    ]);
  };

  const updateNote = (id, field, value) => {
    setNotes(
      notes.map(note =>
        note.id === id ? { ...note, [field]: value } : note
      )
    );
  };

  
  return (
    <Container className="my-4 ">
          <div className="d-flex justify-content-end">
      <Btn attrBtn={{  color: 'primary', onClick: addNote }}
        // variant="success"
        onClick={addNote}
        className="m-3"
      >
        Add New Note
      </Btn>
      {/* <Btn attrBtn={{ color: 'primary', onClick: addNote }}
        // variant="success"
        onClick={addNote}
        className="m-3"
      >
        View Notes
      </Btn> */}
      </div>

      <div className="d-flex flex-wrap">
        {notes.map(note => (
            <div className="m-2" key={note.id}>
              <NoteCard
                note={note}
                onUpdate={(field, value) => updateNote(note.id, field, value)}
                // onDelete={() => deleteNote(note.id)}
              />
            </div>
    
        ))}
      </div>
    </Container>
  );
}

const NoteCard = ({ note, onUpdate, onDelete }) => {
  const [modalOpen, setModalOpen] = useState(true);

  const toggleModal = () => setModalOpen(!modalOpen);

  return (
    <>
      {/* <Card
        className="p-2 note"
        style={{ width: '300px', minHeight: '300px', position: 'relative' }}
      >
        <Button
          variant="danger"
          size="sm"
          className="position-absolute top-0 end-0 m-2"
          onClick={onDelete}
        >
          X
        </Button>
        <Card.Body>
          <Form.Control
            as="input"
            placeholder="Enter your name"
            value={note.name}
            onChange={(e) => onUpdate('name', e.target.value)}
            className="mb-2"
          />
          <Form.Control
            as="input"
            placeholder="Enter note title"
            value={note.title}
            onChange={(e) => onUpdate('title', e.target.value)}
            className="mb-2"
          />
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter note description here"
            value={note.content}
            onChange={(e) => onUpdate('content', e.target.value)}
          />
          <div className="mt-2 text-muted text-end">{note.date}</div>
          <Button
            variant="info"
            className="mt-2"
            onClick={toggleModal}
          >
            Edit Note
          </Button>
        </Card.Body>
      </Card> */}

      <Draggable>
        <Modal className='notes'  isOpen={modalOpen}  size="xs" centered>
          <div className="d-flex justify-content-between bg-info text-secondary">
            <ModalHeader>Notes</ModalHeader>
            <div className='p-3' style={{ cursor: "pointer" }} onClick={toggleModal}>
              <CloseModal />
            </div>
          </div>
          <ModalBody className='bg-info text-secondary'>
            <Form>
              <div className='d-flex justify-content-between'>
                <H5 className='font-secondary'>{'Patient Name'}</H5>
                <Input
                  type='text'
                  className='border-0 shadow-none bg-transparent input-style text-center'
                  placeholder='Enter Title'
                  value={note.name}
                  onChange={(e) => onUpdate('name', e.target.value)}
                />
                <H5>{note.date}</H5>
              </div>
              <div>
                <Input
                className='border-0 shadow-none bg-transparent border-bottom input-style'
                  type='textarea'
                  placeholder='Notes'
                  value={note.content}
                  onChange={(e) => onUpdate('content', e.target.value)}
                />
              </div>
            </Form>
          </ModalBody>
          <ModalFooter className='bg-info'>
            <Btn attrBtn={{ color: 'secondary', onClick: toggleModal }}>Close</Btn>
            <Btn attrBtn={{ color: 'primary', onClick: toggleModal }}>Save Changes</Btn>
          </ModalFooter>
        </Modal>
      </Draggable>
    </>
  );
};

export default AddNotes;
